module.exports = __webpack_public_path__ + "img/car-table-icon.c5438f1a.svg";